<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />

    <b-card>
      <b-row>
        <b-col xl="8" lg="8" md="8" sm="12">
          <h4 v-if="url == null">Adicionar banner</h4>
          <h4 v-else>Editar banner</h4>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="12">
          <b-button
            variant="success"
            class="ml-3 float-right"
            :disabled="!haveImage"
            @click="adicionar"
            >{{ url === null ? "Adicionar" : "Confirmar" }}</b-button
          >
          <b-button variant="danger" class="float-right" @click="goBack"
            >Voltar</b-button
          >
        </b-col>
      </b-row>
    </b-card>
    
    <b-card class="mt-3">
      <b-row>
        <b-col xl="4" lg="6" md="12" sm="12">
          <b-input-group prepend="Opções">
            <b-form-select
              v-model="selectedOption"
              :options="options"
              @change="verificaOpcao()"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col xl="4" lg="6" md="12" sm="12">
          <b-input-group prepend="Promoções">
            <b-form-select
              v-model="selectedPromotion"
              :options="promotions"
              :disabled="!(selectedOption == 2)"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col xl="4" lg="6" md="12" sm="12">
          <b-input-group prepend="Local Exibição">
            <b-form-select
              v-model="selectedLocalExibicao"
              :options="localExibicao"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col xl="12" lg="6" md="12" sm="12">
          <b-input-group prepend="Link">
            <b-form-input
              v-model="link"
              :disabled="!(selectedOption == 5)"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col xl="12" lg="6" md="6" sm="12">
        <b-card header="Imagem" class="mb-0 mt-2">
          <picture-input
            ref="pictureInput"
            margin="1"
            style="width: 20%; heigth: 20%"
            accept="image/*"
            :autoToggleAspectRatio="true"
            :removable="false"
            size="10"
            :zIndex="10"
            button-class="changeBtn"
            removeButtonClass="removeBtn"
            :prefill="url"
            :custom-strings="{
              upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
              drag: 'Arraste uma imagem <br> (ou clique aqui)',
              change: 'Mudar foto',
              remove: 'Remover foto',
            }"
            @change="onChange"
          ></picture-input>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import PictureInput from "vue-picture-input";
import Loading from "vue-loading-overlay";

export default {
  components: { PictureInput, Loading },
  data: () => {
    return {
      isLoading: false,
      link: null,
      url: null,
      haveImage: false,
      selectedOption: null,
      selectedPromotion: null,
      selectedLocalExibicao: null,
      promotions: [],
      imagem: null,
      id: null,
      localExibicao: [
        {
          value: 1,
          text: "Página Principal",
        },
        {
          value: 2,
          text: "Página de Produtos",
        },
      ],
      options: [
        {
          value: null,
          text: "Comum",
        },
        {
          value: 1,
          text: "Jornalzinho",
        },
        {
          value: 2,
          text: "Promoção",
        },
        {
          value: 3,
          text: "Sorteios",
        },
        {
          value: 4,
          text: "Cupom",
        },
        {
          value: 5,
          text: "Link",
        },
      ],
    };
  },
  methods: {
    verificaOpcao(){
      if (this.selectedOption != 5) {
        this.link = null;
      }
    },

    retornaRedirect(selecionado) {
      switch (selecionado) {
        case null:
          return -3;
        case 1:
          return "jornalzinho";
        case 2:
          return this.selectedPromotion;
        case 3:
          return -1;
        case 4:
          return -2;
        case 5:
          return this.link;
      }
    },

    validarCampos() {
      if (this.selectedOption == 2) {
        if (
          this.selectedPromotion == null ||
          this.selectedPromotion == undefined
        )
          return {
            error: true,
            message: "Necessário inserir uma promoção válida para continuar!",
          };
      } else if (this.selectedOption == 5) {
        if (this.link != null) {
          const urlLink =
            /((ht|f)tp(s)?:\/\/)?(w{0,3}\.)?[a-zA-Z0-9_\-.:/~}]+(\.[a-zA-Z]{1,4})(\/[a-zA-Z0-9_\-.:/~}]*)?/g;
          if (!urlLink.test(this.link)) {
            return {
              error: true,
              message: "Necessário inserir um link válido para continuar!",
            };
          }
        } else if (this.link == null || this.link == "") return false;
      }

      return { error: false, message: "" };
    },
    async adicionar() {
      this.isLoading = true;

      const validarCampos = this.validarCampos();

      if (!validarCampos.error) {
        if (this.selectedOption != 2) {
          localStorage.removeItem("selectedPromotionID");
          this.selectedPromotion = 0;
        }

        if (this.selectedOption != 5) {
          localStorage.removeItem("redirect_banner");
          this.link = null;
        }

        if (this.url == null) {
          const urlPost = `${config.default.servidor}/gerencial/banner`;

          try {
            const response = await axios({
              url: urlPost,
              method: "post",
              data: {
                empresaid: localStorage.getItem("enterprise_id"),
                imagem: this.imagem,
                local: this.selectedLocalExibicao,
                redirecionar: this.retornaRedirect(this.selectedOption),
                bannerType: this.selectedOption,
                promotionId: this.selectedPromotion,
              },
              headers: {
                authorization: `${config.default.authorizationBasic}`,
              },
            });

            if (response.status == 200) {
              this.isLoading = false;
              this.$alert("Banner adicionado!", "Sucesso", "success");
              this.goBack();
            } else {
              this.$alert("Falha ao adicionar o banner!", "Erro", "error");
            }
          } catch (error) {
            console.log({ error });
            this.isLoading = false;
            this.$alert("Falha ao adicionar o banner!", "Erro", "error");
          }
        } else {
          console.info({
            empresaid: localStorage.getItem("enterprise_id"),
            bannerid: this.id,
            imagem: this.imagem,
            local: this.selectedLocalExibicao,
            redirect: this.retornaRedirect(this.selectedOption),
            link: this.link,
            bannerType: this.selectedOption,
            promotionId: this.selectedPromotion,
          });
          const urlPut = `${config.default.servidor}/gerencial/banner/img`;
          try {
            const response = await axios({
              url: urlPut,
              method: "put",
              data: {
                empresaid: localStorage.getItem("enterprise_id"),
                bannerid: this.id,
                imagem: this.imagem,
                local: this.selectedLocalExibicao,
                redirect: this.retornaRedirect(this.selectedOption),
                bannerType: this.selectedOption,
                promotionId: this.selectedPromotion,
              },
              headers: {
                authorization: `${config.default.authorizationBasic}`,
              },
            });

            if (response.status == 200) {
              this.isLoading = false;
              this.$alert("Banner editado!", "Sucesso", "success");
              this.goBack();
            } else {
              this.isLoading = false;
              this.$alert("Falha ao editar o banner!", "Erro", "error");
            }
          } catch (error) {
            console.log({ error });
            this.isLoading = false;
            this.$alert("Falha ao editar o banner!", "Erro", "error");
          }
        }
      } else {
        this.isLoading = false;
        this.$alert(validarCampos.message, "Aviso", "warning");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    onChange(image) {
      if (image) {
        this.haveImage = true;
        this.imagem = image;
      }
    },
    async getIdPromocoes() {
      const url = `${
        config.default.servidor
      }/gerencial/promocoes/id/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: {
            authorization: `${config.default.authorizationBasic}`,
          },
        });

        if (response.status == 200) {       
          this.promotions = response.data.data;

          this.id = localStorage.getItem("id_banner");
          this.url = localStorage.getItem("url_banner");
          this.selectedLocalExibicao = localStorage.getItem(
            "localExibicaoBanner"
          );
          this.selectedOption = localStorage.getItem("selectedOptionID");
          if (this.selectedOption != 2) {
            this.selectedPromotion = null;
          } else {
            this.selectedPromotion = localStorage.getItem(
              "selectedPromotionID"
            );
          }
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getIdPromocoes();
    var editar = Boolean(localStorage.getItem("editar_banner"));
    if (editar) {
      this.haveImage = true;

      const urlPattern =
        /((ht|f)tp(s)?:\/\/)?(w{0,3}\.)?[a-zA-Z0-9_\-.:/~}]+(\.[a-zA-Z]{1,4})(\/[a-zA-Z0-9_\-.:/~}]*)?/g;
        
      var redirect = localStorage.getItem("redirect_banner");

      if (redirect == "jornalzinho") {
        this.selectedOption = 1;
      } else if (urlPattern.test(redirect)) {
        this.selectedOption = 5;
        this.link = redirect;
      } else {
        redirect = parseInt(redirect);
        if (redirect < 0) {
          if (redirect == -1) {
            this.selectedOption = 3;
          } else if (redirect == -2) {
            this.selectedOption = 4;
          } else {
            this.selectedOption = null;
          }
        } else {
          if (redirect == 2) {
            this.selectedOption = 2;
            this.selectedPromotion = redirect;
          }
        }
      }
    }

    this.isLoading = false;
  },
};
</script>